import { Tooltip, IconInform16, Label } from '@cian/ui-kit';
import { clsx as cx } from 'clsx';
import * as React from 'react';

import * as styles from './BlockListItem.css';
import { IResultBlock, EBlockType } from '../../../../types/calculate';

interface IBlockListItemProps extends IResultBlock {
  profitable: boolean;
  deviceType: string;
}

export const BlockListItem: React.VFC<IBlockListItemProps> = ({
  title,
  price,
  time,
  profitable,
  deviceType,
  type,
}: IBlockListItemProps) => {
  return (
    <li className={styles['blocks-list-item']}>
      <div className={styles['title']}>
        {title}
        {profitable && (
          <Label background="success_10" color="success_100">
            Выгоднее
          </Label>
        )}
      </div>
      <div className={styles['row']}>
        {price.label} {price.value}
        {type === EBlockType.Deposit && (
          <Tooltip
            theme="white"
            title={
              <span className={cx(styles['tooltip-text'], styles[`tooltip-text--${deviceType}`])}>
                Если копить, квартира со временем дорожает
              </span>
            }
            placement="bottom-start"
          >
            <IconInform16 color="primary_100" />
          </Tooltip>
        )}
      </div>
      <div className={styles['row']}>
        {time.label} {time.value}
      </div>
    </li>
  );
};
